<template>
  <div class="online-training">
    <!-- <p class="title">{{$t('driver_onboarding.training.step')}}</p>
    <h1>{{$t('driver_onboarding.training.title')}}</h1>

    <div class="take-note">
      <h3>{{$t('driver_onboarding.training.require_course.title')}}</h3>
      <span>{{$t('driver_onboarding.training.require_course.description')}}</span>
      <br />
      <span v-html="$t('driver_onboarding.training.require_course.note')"></span>
    </div>
    <div class="courses-required">
      <RequiredCourses v-if="!loading" :courses="requiredCourses" />
    </div>
    <a v-if="mobileViewWidth <= 1024" :disabled="!nextStepButtonVisible" class="button go-on btn-mobile" :href="closeView">{{$t('driver_onboarding.training.next_step')}}</a>
    <b-button v-else class="go-on" :disabled="!nextStepButtonVisible" @click="nextStep">{{$t('driver_onboarding.training.next_step')}}</b-button>
    <br />
    <p class="note-to-pass" v-html="$t('driver_onboarding.training.note',{coursesLength : requiredCourses.length})"></p>
    <hr />

    <div class="take-note">
      <h3>{{$t('driver_onboarding.training.normal_course.title')}}</h3>
      <span>
        {{$t('driver_onboarding.training.normal_course.description')}}
      </span>
    </div>
    <div class="courses-normal">
      <NormalCourses v-if="!loading" :courses="notRequiredCourses" />
    </div>
     <b-loading :is-full-page="loading" :active.sync="loading" :can-cancel="true"></b-loading> -->
  </div>
</template>
<script>
// import RequiredCourses from "./RequiredCourses";
// import NormalCourses from "./NormalCourses";
import { mapGetters } from "vuex";
import dsBridge from 'dsbridge'
import { EVENT } from "@/mixins/event-tracking"

export default {
  components: {
    // RequiredCourses,
    // NormalCourses
  },
  computed: {
    ...mapGetters(["courses","supplierProfile", "supplierToken", "requiredCourses", "notRequiredCourses", "nextStepButtonVisible"]),
    mobileViewWidth(){
      return screen.width
    },
    closeView() {
      let params = "?is_close_view=true"
      let url  = this.nextStepButtonVisible ? `/training-v1${params}` : `javascript:;`
      return url
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    nextStep() {
      this.$router.push({ name: "contract" });
      this.$gtag('event',this.$trackingEvents.EVENTS.SUBMIT_TRAINING, {'event_category' : this.$route.path})

      let params = {
        event_name : EVENT.ONLINETRAINING_CONTINUE_BTN,
        data : {
          supplier_id : this.supplierProfile._id,
          city_id : this.supplierProfile.city_id
        }
      }
      if(dsBridge.hasNativeMethod('trackEvent')) {
        dsBridge.call('trackEvent', JSON.stringify(params))
      }
    },
  },
  created() {
    window.open(`/courses?token=${this.supplierToken}`, '_self');
    if (!this.courses || this.courses.length === 0) {
        this.loading = true
        this.$store.dispatch("getAllCourses", this.supplierToken)
        .finally(() => {
          this.loading = false 
        })
    }
  }
};
</script>
<style lang="scss">
.online-training {
  p.title{
    color: #bcbcbc;
    font-size: 16px;
    margin-bottom: 4px;
    font-weight: 500;
  }
  h1 {
    margin: 0 0 20px 0;
    color: #1a1a1a;
  }
  .take-note {
    max-width: 500px;
    h3 {
      color: #ff8200;
      font-size: 20px;
      margin-bottom: 4px;
    }
    span {
      margin-top: 15px;
      color: #7a8189;
      font-size: 14px;
    }
  }
  p.note-to-pass{
    margin-top: 10px;
    font-size: 14px;
    color: #7A8189;
  }

  button.go-on,
  a.go-on{
    width: 120px;
    height: 46px;
    background: #ff8200;
    color: #fff;
    border-radius: 2px;
    margin-top: 25px;
  }
}
</style>
